import {
    actionsLanguage as actions
} from "../actions/types";

const languageReducer = (state = null, action: any) => {
    switch (action.type) {
        case actions.SET_LANGUAGE:
            return action.payload;
        default:
            return state;
    }
}

export default languageReducer;